import Vue from "vue";
import VueGtag from "vue-gtag";
import router from "./router";
//console.log("Turn on Google Analytics");
if (process.env.VUE_APP_GOOGLE_ANALYTICS_TRACKING_ID) {
  Vue.use(
    VueGtag,
    {
      config: {
        id: process.env.VUE_APP_GOOGLE_ANALYTICS_TRACKING_ID
      },
      deferScriptLoad: true,
      pageTrackerEnabled: false
    },
    router
  );
}
